import { Component, OnInit, Input } from '@angular/core';

import { UserIFace } from 'src/app/shared/classes';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-user-show',
  templateUrl: './user-show.component.html',
  styleUrls: ['./user-show.component.less']
})
export class UserShowComponent implements OnInit {
  @Input() user: UserIFace;

  public showUser = true;
  public showAdmin = true;

  public userInfo = {
    fullName: '',
    user_id: '',
    admin_id: '',
    email: '',
    country: '',
    company: '',
    account_type: '',
    rwAPI: '',
    readAPI: '',
    registerOn: '',
    subscription: {
      account: {
        type: '',
        code: '',
        expired: '',
        trial:'not available'
      },
      sms: ''
    }
  };

  constructor(private util: UtilsService) { }

  ngOnInit() {
    this.setUpUserData();
  }

  // sets up the user info data to the show form
  private setUpUserData() {
    if (this.user.from === 'users') {
      this.userInfo.fullName = this.user.data.name;
      this.userInfo.user_id = this.user.data.user_id;
      this.userInfo.email = this.user.data.email;
      this.userInfo.country = this.user.data.country;
      this.userInfo.company = this.user.data.company;
      this.userInfo.account_type = this.user.data.account_type;
      this.userInfo.rwAPI = this.user.data.readWriteAPI;
      const subscription = JSON.parse(this.user.data.subscription);
      if (subscription !== null) {
        this.userInfo.subscription.account.type = this.util.returnItem(subscription, 'subs');
        this.userInfo.subscription.account.expired = this.util.returnItem(subscription, 'exp');
        this.userInfo.subscription.account.code = this.util.returnItem(subscription, 'code') || "not available";
        if(subscription.account.trial != null){
           if(subscription.account.trial == true){
              this.userInfo.subscription.account.trial = "active";
             }
          }
      
      
        if (subscription.hasOwnProperty('sms')) {
          this.userInfo.subscription.sms = this.util.returnItem(subscription, 'sms');
        }
      }
      this.userInfo.readAPI = this.user.data.readAPI;
      this.userInfo.registerOn = this.user.data.date;

      // show elems
      this.showAdmin = true;
      this.showAdmin = false;
    }

    if (this.user.from === 'admins') {
      this.userInfo.fullName = this.user.data['name'];
      this.userInfo.admin_id = this.user.data['admin_id'];
      this.userInfo.email = this.user.data['email'];
      this.userInfo.country = this.user.data['country'];
      this.userInfo.company = this.user.data['organisation'];
      this.userInfo.account_type = this.user.data['sub_account_type'];
      this.userInfo.registerOn =  this.user.data['start_date']
      this.userInfo.rwAPI = this.user.data['rw_api'];
      this.userInfo.readAPI = this.user.data['read_api'];
      // this.userInfo.registerOn = this.user.data['start_date'];
      // if(this.user.data.subscription != null){
      //   const subscription = JSON.parse(this.user.data.subscription);
      //   this.userInfo.subscription.account.type = this.util.returnItem(subscription, 'subs');
      //   this.userInfo.subscription.account.expired = this.util.returnItem(subscription, 'exp');
       
      // }

      // hide elements
      this.showUser = false;
      this.showAdmin = true;
    }
  }
}
